import PurchaseOrderClient from "./clients/PurchaseOrderClient";

const entitiesPath = "entities";

export default {
  getEntities(body) {
    return PurchaseOrderClient.post(`${entitiesPath}/entities`, body);
  },
  getEntitiesEP(id, type) {
    return PurchaseOrderClient.get(
      `${entitiesPath}/epEntities/${id}/${type}`
    );
  },
  setEntityEP(id, data) {
    return PurchaseOrderClient.put(
      `${entitiesPath}/epEntities/${id}`,
      data
    );
  }
};
